// extracted by mini-css-extract-plugin
module.exports = {"container":"IconBadge_container__3OiyB","small":"IconBadge_small__2TLq7","count-icon":"IconBadge_count-icon__2_txj"};